import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const logOutIcon = svgToTinyDataUri(
  `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8214_54099)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.66667 0C7.03486 0 7.33333 0.298477 7.33333 0.666667C7.33333 1.03486 7.03486 1.33333 6.66667 1.33333H2.66667C2.29848 1.33333 2 1.63181 2 2V14C2 14.3682 2.29848 14.6667 2.66667 14.6667H6.66667C7.03486 14.6667 7.33333 14.9651 7.33333 15.3333C7.33333 15.7015 7.03486 16 6.66667 16H2.66667C1.5621 16 0.666667 15.1046 0.666667 14V2C0.666667 0.895431 1.5621 0 2.66667 0H6.66667Z" fill="#2B2A35"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.8619 4.19526C11.1223 3.93491 11.5444 3.93491 11.8047 4.19526L15.1381 7.5286C15.3984 7.78894 15.3984 8.21105 15.1381 8.4714L11.8047 11.8047C11.5444 12.0651 11.1223 12.0651 10.8619 11.8047C10.6016 11.5444 10.6016 11.1223 10.8619 10.8619L13.0572 8.66667H5.33333C4.96514 8.66667 4.66667 8.36819 4.66667 8C4.66667 7.63181 4.96514 7.33333 5.33333 7.33333H13.0572L10.8619 5.13807C10.6016 4.87772 10.6016 4.45561 10.8619 4.19526Z" fill="#2B2A35"/>
</g>
<defs>
<clipPath id="clip0_8214_54099">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>`
);
